<template>
    <div class="schema-form">
        <component
            v-for="fieldSchema in schemaBased.fields.filter(f => !f.invisible)"
            :key="fieldSchema.name"
            :is="mapComponentType(fieldSchema)"
            :fieldSchema="fieldSchema"
            ref="components"
        />
    </div>
</template>

<script>
import MapField from "./MapField.vue";
import StringField from "./StringField.vue";
import BooleanField from "./BooleanField.vue";
import ChoiceField from "./ChoiceField.vue";
import ListField from "./ListField.vue";
import ListOptionField from "./ListOptionField.vue";
import GroupedField from './GroupedField.vue';
import OptionField from "./OptionField.vue";

export default {
  name: "app-config-form",

  props: {
    schemaBased: {
      type: Object,
      default: []
    }
  },

  methods: {
    mapComponentType(fieldSchema) {
      if (fieldSchema.type == 'list') {
        if (fieldSchema.list_type == 'option') {
          return 'ListOptionField';
        } else {
          return 'ListField';
        }
      }

      const typeMapping = {
        string: 'StringField',
        number: 'StringField',
        password: 'StringField',
        boolean: 'BooleanField',
        choice: 'ChoiceField',
        map: 'MapField',
        group: 'GroupedField',
        option: 'OptionField',
      };
      const component = typeMapping[fieldSchema.type];

      if (!component) {
        console.error(`Tipo de campo desconhecido: ${fieldSchema.type}`);
      }
      return component;
    },

    validate() {
      if (!this.$refs.components) {
        return true;
      }
      let isValid = true;

      this.$refs.components
        .filter(component => component.validate)
        .forEach(component => {
          if (!component.validate()) {
            isValid = false;
          }
      });

      return isValid;
    }
  },

  components: {
    MapField,
    StringField,
    BooleanField,
    ChoiceField,
    ListField,
    ListOptionField,
    GroupedField,
    OptionField,
  },
};
</script>

<style lang='scss'>

.schema-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-right: 2rem;
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/AppConfigForm.vue?7253bd9c